(function () {
  const contentTextEls = document.querySelectorAll('.voo-news-slider__content-text');
  if (contentTextEls.length === 0) return;

  contentTextEls.forEach((element) => {
    if (element.querySelector('.voo-news-slider__content-truncate-text')) {
      element.classList.add('hide-truncate');
    }
  });
})();